var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Panel',{attrs:{"data":_vm.consult}}),_c('hr'),_c('h3',[_vm._v("Requisições")]),(_vm.consult && _vm.consult.id)?_c('Requests',{attrs:{"consult":_vm.consult}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }